import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { Subscription } from 'rxjs';
import { MultiBuyerService } from '../../shared/services/multi-buyer/multi-buyer-service';
import { AuthService } from '../../auth/auth.service';
import { MultiBuyerCmp } from '../../shared/interfaces/company.interface';

@Component({
  selector: 'ps-multi-buyer-modal',
  templateUrl: './multi-buyer-modal.component.html',
  styleUrls: ['./multi-buyer-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class MultiBuyerModalComponent implements OnInit, OnDestroy {
  multiBuyersCmpsList: MultiBuyerCmp[] = [];
  selectedCompany?: MultiBuyerCmp;
  private _subscriptions: Subscription = new Subscription();

  constructor(
    @Inject(ModalData)
    private _modalData: {
      cmpId: number;
      buyerCompanyId: number;
    },
    readonly _modalRef: ModalRef<MultiBuyerModalComponent, string>,
    readonly _auth: AuthService,
    readonly _toastr: ToasterService,
    readonly _multiBuyerService: MultiBuyerService
  ) {}

  ngOnInit(): void {
    this._auth.selectedMultiBuyerCompany$.subscribe(() => {
      this.selectedCompany = this._auth.selectedMultiBuyerCompany;
    });
    this._getMultiBuyersCmpsList();
  }

  public async _getMultiBuyersCmpsList() {
    const buyersCmps = await this._multiBuyerService
      .getMultiBuyerCmpsListPromise(
        this._modalData.cmpId,
        this._modalData.buyerCompanyId!
      )
      .catch((error: Error) => {
        console.error(error);
        throw error;
      });

    this.multiBuyersCmpsList = buyersCmps;
  }

  public clearBuyer() {
    this.selectedCompany = undefined;
  }

  public async setBuyerDetails() {
    if (!this.selectedCompany?.id) {
      this._auth.resetMultiBuyerToken();
      this._modalRef.close();
      return;
    }

    await this._multiBuyerService
      .selectBuyerPromise(this._modalData.cmpId, this.selectedCompany.id)
      .catch((error) => {
        this._toastr.error(error);
      });

    this._modalRef.close();
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
}
